import { createGlobalStyle } from "styled-components";
import UniversLightWoff from "@fonts/univers-light.woff";
import UniversLightWoff2 from "@fonts/univers-light.woff2";
import UniversRomanWoff from "@fonts/univers-roman.woff";
import UniversRomanWoff2 from "@fonts/univers-roman.woff2";
import UniversBoldWoff from "@fonts/univers-bold.woff";
import UniversBoldWoff2 from "@fonts/univers-bold.woff2";
import UniversBoldCondWoff from "@fonts/univers-bold-cond.woff";
import UniversBoldCondWoff2 from "@fonts/univers-bold-cond.woff2";
import BeingRegularWoff from "@fonts/being-regular.woff";
import BeingRegularWoff2 from "@fonts/being-regular.woff2";
import OutwardBlockWoff from "@fonts/outward-block.woff";
import OutwardBlockWoff2 from "@fonts/outward-block.woff2";
import ThunderBlackLCWoff from "@fonts/thunder-blacklc.woff";
import ThunderBlackLCWoff2 from "@fonts/thunder-blacklc.woff2";
import AkzidenzGroteskBoldWoff from "@fonts/akzidenz-grotesk-bold.woff";
import AkzidenzGroteskBoldWoff2 from "@fonts/akzidenz-grotesk-bold.woff2";
import EditorialNewRegularWoff from "@fonts/editorialnew-regular.woff";
import EditorialNewRegularWoff2 from "@fonts/editorialnew-regular.woff2";

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: "univers-light";
    src: local("univers-light"), url(${UniversLightWoff2}) format("woff2"),
      url(${UniversLightWoff}) format("woff");
  }

  @font-face {
    font-family: "univers-roman";
    src: local("univers-roman"), url(${UniversRomanWoff2}) format("woff2"),
      url(${UniversRomanWoff}) format("woff");
  }

  @font-face {
    font-family: "univers-bold";
    src: local("univers-bold"), url(${UniversBoldWoff2}) format("woff2"),
      url(${UniversBoldWoff}) format("woff");
  }

  @font-face {
    font-family: "univers-bold-cond";
    src: local("univers-bold-cond"), url(${UniversBoldCondWoff2}) format("woff2"),
      url(${UniversBoldCondWoff}) format("woff");
  }

  @font-face {
    font-family: "being-regular";
    src: local("being-regular"), url(${BeingRegularWoff2}) format("woff2"),
      url(${BeingRegularWoff}) format("woff");
  }
      @font-face {
    font-family: "outward-block";
    src: local("outward-block"), url(${OutwardBlockWoff2}) format("woff2"),
      url(${OutwardBlockWoff}) format("woff");
  }
      @font-face {
    font-family: "thunder-blacklc";
    src: local("thunder-blacklc"), url(${ThunderBlackLCWoff2}) format("woff2"),
      url(${ThunderBlackLCWoff}) format("woff");
  }

  @font-face {
    font-family: "akzidenz-grotesk-bold";
    src: local("akzidenz-grotesk-bold"), url(${AkzidenzGroteskBoldWoff2}) format("woff2"),
      url(${AkzidenzGroteskBoldWoff}) format("woff");
  }

  @font-face {
    font-family: "editorialnew-regular";
    src: local("editorialnew-regular"), url(${EditorialNewRegularWoff2}) format("woff2"),
      url(${EditorialNewRegularWoff}) format("woff");
  }

  html {
    font-size: 17px; 
  }

  body {
        margin: 0;
        overflow-x: clip;
      }

      body::-webkit-scrollbar {
        display: none;
      }

        #___gatsby {
        margin: 0;
        font-size: 17px;
        font-family: "univers-light", sans-serif;
        line-height: 1.6;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        overflow-x: hidden;
        color: rgba(33, 23, 3, 1);
        box-sizing: border-box;
        margin: 0;
        overflow-x: clip;
      }

   a,
      a:visited {
        color: black;
        text-decoration: none;
      }

       button {
        padding: 0px;

        button:hover,
        button:focus {
          outline: none;
        }
      }
        
      img {
        max-width: 100%;
      }
`;

export default GlobalStyles;
